// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"FacetMenuItem_menuItem__3XB0B","caption":"FacetMenuItem_caption__1xDtF"};